// extracted by mini-css-extract-plugin
module.exports = {"signInButton":"NavigationButtons_signInButton__3ZdEc"};